import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SortableItemUIProps } from '@progress/kendo-react-sortable';
import cn from 'clsx';
import styles from './style.module.scss';
import Button from '@components-clean/core/button';
import { RowDataSourceTable } from '@interfaces/filter-context.interface';
import { useTranslation } from '@hooks/index';

export interface FilterListDataItem {
    id: number;
    isEdit: boolean;
    fieldKey: string;
    fieldName: string;
    labelText?: string;
    filterContext?: RowDataSourceTable;
    createdByName?: string;
    createdDate?: string;
    onEdit?: (fieldKey: string) => void;
    onDelete?: (fieldKey: string) => void;
    isDefault?: boolean;
    displayIndex?: number;
}

export interface LastUpdatedFields {
    lastUpdatedDate: string;
    updatedByName: string;
}

interface FilterListItemProps extends SortableItemUIProps {
    dataItem: FilterListDataItem;
    selectedItem?: string | null;
}

const FilterListItem = ({
    isDisabled,
    isActive,
    style,
    attributes,
    forwardRef,
    selectedItem,
    dataItem: { isEdit, labelText, fieldKey, fieldName, onEdit, onDelete, isDefault },
}: FilterListItemProps) => {
    const { t } = useTranslation();

    return (
        <div
            ref={forwardRef}
            {...attributes}
            style={style}
            className={cn(
                'k-pos-relative k-d-flex k-align-items-center k-mb-2 k-py-1 k-pr-1.5 k-pl-10 k-rounded-lg',
                styles.listItem,
                {
                    [styles.active]: isActive && !isDisabled,
                    [styles.disabled]: isDisabled,
                    [styles.selected]: selectedItem === fieldKey,
                },
            )}
        >
            {isEdit && (
                <div className="k-pos-absolute k-cursor-grab k-left-3.5 k-top-3">
                    <FontAwesomeIcon icon={['fas', 'grip-dots-vertical']} className={cn('fa-lg', styles.dragIcon)} />
                </div>
            )}
            <div>
                <div className={styles.textWrap}>
                    <span className={styles.label}>{t('label')}:</span>
                    <span className={styles.value}>{labelText}</span>
                </div>
                <div className={styles.textWrap}>
                    <span className={styles.label}>{t('field')}:</span>
                    <span className={styles.value}>{fieldName}</span>
                </div>
            </div>
            {isEdit && (
                <div className="k-ml-auto">
                    {!isDefault && (
                        <Button onClick={() => onDelete && onDelete(fieldKey)} data-testid="cancel-button">
                            {t('delete')}
                        </Button>
                    )}
                    <Button
                        onClick={() => onEdit && onEdit(fieldKey)}
                        data-testid="edit"
                        primary
                        className={styles.editBtn}
                    >
                        {t('edit')}
                    </Button>
                </div>
            )}
        </div>
    );
};
export default FilterListItem;
